import { applyDocumentNavigatorPermissionAliases } from 'features/permissions/utils/documentNavigatorPermissions'
import { geckoPerms, PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

export function permissionsFromRoleNames(
  roleNames: readonly string[],
  viewerAssigned?: boolean
): Set<string> {
  const maskedPermissions = new Set(roleNames)
  if (!maskedPermissions.has(PERMISSION_GECKO_INTERNAL_MEMBER)) {
    geckoPerms.forEach((p) => maskedPermissions.delete(p))
  }
  return applyDocumentNavigatorPermissionAliases(
    maskedPermissions,
    viewerAssigned
  )
}
